/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import keys from 'lodash.keys';
import isOrderAssignedToUser from '@app/util/is-order-assigned-to-user';
import OrderSnippet from '../OrderSnippet';
import OrdersPanelHeader from '../OrderPanelHeader';

const OrderPanelSection = props => {
  const {
    sectionName,
    emptyMessage,
    orders,
    dealers,
    activeOrder,
    dismissOrder,
    cancelDelivery,
    router,
    offset,
    setCurrentOrder,
    intl,
    userId,
    filterComponent,
  } = props;

  const reduceNumberOfDealers = (accum, dealerId) => {
    const hasId = !!dealers[dealerId].id;

    if (hasId) {
      return accum + 1;
    }

    return accum;
  };
  const displayDealerName = keys(dealers).reduce(reduceNumberOfDealers, 0) > 1;

  const mapOrders = order => {
    const isAssignedToCurrentUser = isOrderAssignedToUser(userId, order);
    return (
      <div key={order.id} className="OrderPanel__snippet_wrapper">
        <OrderSnippet
          order={order}
          active={activeOrder && order.id === activeOrder.id}
          dealer={dealers[order.dealerId]}
          router={router}
          dismissOrder={dismissOrder}
          cancelDelivery={cancelDelivery}
          displayDealerName={displayDealerName}
          offset={offset}
          setCurrentOrder={setCurrentOrder}
          intl={intl}
          isAssignedToCurrentUser={isAssignedToCurrentUser}
          userId={userId}
        />
      </div>
    );
  };
  const renderOrders = () => {
    if (orders.length) {
      return orders.map(mapOrders);
    }

    return <div>{emptyMessage}</div>;
  };

  return (
    <section className="OrderPanel__section">
      <OrdersPanelHeader title={sectionName} filterComponent={filterComponent} />
      <div>{renderOrders()}</div>
    </section>
  );
};

OrderPanelSection.propTypes = {
  sectionName: PropTypes.string,
  emptyMessage: PropTypes.string,
  orders: PropTypes.array,
  dealers: PropTypes.object,
  activeOrder: PropTypes.object,
  dismissOrder: PropTypes.func,
  cancelDelivery: PropTypes.func,
  router: PropTypes.object,
  offset: PropTypes.number,
  setCurrentOrder: PropTypes.func,
  intl: PropTypes.object,
  userId: PropTypes.string,
  filterComponent: PropTypes.node,
};

export default OrderPanelSection;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderPanelSection/OrderPanelSection.jsx